import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { listOfDocumentsFilterFields } from "./fields";

const ListOfDocumentsFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => listOfDocumentsFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={3} />;
};

export default ListOfDocumentsFilter;
